import { useFormatDateTime, useMessage } from "@hermes/intl";
import {
  ButtonV2,
  createStaticStyles,
  cssFns,
  DatePicker,
  Presets,
  useFormField,
  useRadioGroupState,
  useStaticStyles,
} from "@hermes/ui";
import { Temporal } from "@hermes/utils";
import { useEffect } from "react";

import { containerBorderBlockEndStyles } from "../quick-modal";

const styles = {
  container: createStaticStyles.clean({ paddingBlockEnd: 20 }),
  presets: createStaticStyles({
    common: cssFns.padding(16, 0),
  }),
};

export const DateShort = ({
  date,
  onDateChange,
}: {
  date: Temporal.PlainDate | undefined;
  onDateChange: (date: Temporal.PlainDate | undefined) => void;
}) => {
  const message = useMessage();
  const formatDateTime = useFormatDateTime();
  const now = Temporal.Now.plainDateISO();
  const tomorrow = now.add({ days: 1 });
  const { staticStyles } = useStaticStyles();

  const presetField = useFormField(
    useRadioGroupState({
      value:
        date?.toString() === now.toString()
          ? now.toString()
          : date?.toString() === tomorrow.toString()
            ? tomorrow.toString()
            : "",
    }),
  );

  useEffect(() => {
    presetField.onChange({
      value: date?.toString() ?? "",
    });
  }, [date?.toString()]);

  return (
    <div css={[containerBorderBlockEndStyles, styles.container]}>
      <div css={[staticStyles(styles.presets)]}>
        <Presets
          label={message({ id: "common.fields.appointment-date" })}
          field={presetField}
          additionalOptions={
            date &&
            date.toString() !== now.toString() &&
            date.toString() !== tomorrow.toString()
              ? [
                  {
                    label: formatDateTime(date, {
                      weekday: "short",
                      day: "numeric",
                      month: "long",
                    }),
                    value: `${date}`,
                  },
                ]
              : []
          }
          onSelectionChange={(value) => {
            if (value && value.value !== "") {
              onDateChange(Temporal.PlainDate.from(value.value));
            } else {
              onDateChange(undefined);
            }
          }}
        />
      </div>
      <DatePicker
        value={date}
        onChange={onDateChange}
        disabled={{
          before: new Date(),
        }}
        mobile={{
          title: message({
            id: "common.fields.appointment-date",
          }),
          height: "100%",
        }}
      >
        {({ triggerRef, triggerProps }) => (
          <ButtonV2
            text={message({
              id: "common.fields.another-date",
              default: "Choose another date",
            })}
            triggerRef={triggerRef}
            triggerProps={triggerProps}
            active={!!date}
            styles={cssFns.typo({ weight: "regular", level: "body-1" })}
            variant="link-non-text-decorated"
          />
        )}
      </DatePicker>
    </div>
  );
};
